var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.menu !== null)?_c('div',{ref:"home"},[_c('Layout',{attrs:{"menu":_vm.menu}},[_c('transition',[_c('router-view')],1)],1)],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }